module.exports = __webpack_public_path__ + "img/IMG_9185.17284e66.jpg";